import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { FaBullhorn } from "react-icons/fa";

const marqueeData = [
    { text: "Call for Social Innovation (SDG 6: Clean Water & Sanitation): Build solutions for impact", link: 'https://forms.gle/SqqNMfV8vTf4C7Pr9' },
    { text: "Call for Defence Startups: Join IIT Ropar TBIF & DRIF to drive Deep-Tech innovation", link: 'https://forms.gle/SbLmejAdbuuQzsrB6' },
    { text: "EmpowerHer: 5-Day Entrepreneurial Program for Women Leaders- Register Now!", link: 'https://forms.gle/E4fj8Y2QJxsFNLjR7' },
    { text: "Internship Opportunity at Lino Bud - Apply Now!", link: 'mailto:linobuddy.ai@gmail.com' },
];

const Updates = () => {
    return (
        <div className="w-full bg-slate-900 border-b border-slate-800 h-12 flex items-center">
            <div className="bg-blue-600 h-full flex items-center px-4 md:px-6 z-10 shrink-0">
                <FaBullhorn className="text-white mr-2" />
                <span className="text-white font-bold text-sm uppercase tracking-wider hidden md:block">Latest Updates</span>
            </div>
            <Marquee speed={50} gradient={false} className="flex-1">
                {marqueeData.map((data, i) => (
                    <div key={i} className="mx-8 flex items-center">
                        <Link to={data.link} className="text-gray-300 hover:text-white hover:underline text-sm font-medium transition-colors">
                            {data.text}
                        </Link>
                        <span className="ml-8 text-slate-600">|</span>
                    </div>
                ))}
            </Marquee>
        </div>
    );
};

export default Updates;